import React from 'react'

const Neutral = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0001 1.66666C5.40008 1.66666 1.66675 5.39999 1.66675 9.99999C1.66675 14.6 5.40008 18.3333 10.0001 18.3333C14.6001 18.3333 18.3334 14.6 18.3334 9.99999C18.3334 5.39999 14.6001 1.66666 10.0001 1.66666ZM10.0001 16.6667C6.32508 16.6667 3.33341 13.675 3.33341 9.99999C3.33341 6.32499 6.32508 3.33332 10.0001 3.33332C13.6751 3.33332 16.6667 6.32499 16.6667 9.99999C16.6667 13.675 13.6751 16.6667 10.0001 16.6667Z"
      fill="#2D54E8"
    />
    <rect x="2" y="9.20001" width="16" height="1.6" fill="#2D54E8" />
  </svg>
)

export default Neutral
